var React = require('react');

function GolfCourse (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.9165 18C17.6069 18 18.1665 17.4404 18.1665 16.75C18.1665 16.0596 17.6069 15.5 16.9165 15.5C16.2261 15.5 15.6665 16.0596 15.6665 16.75C15.6665 17.4404 16.2261 18 16.9165 18Z","fill":"#616466","key":0}),React.createElement("path",{"d":"M14.8333 5.43366L8.16667 2.16699V17.167H6.5V15.7253C5.00833 16.017 4 16.5503 4 17.167C4 18.0837 6.24167 18.8337 9 18.8337C11.7583 18.8337 14 18.0837 14 17.167C14 16.342 12.2 15.6587 9.83333 15.5253V7.98366L14.8333 5.43366Z","fill":"#616466","key":1})]);
}

GolfCourse.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = GolfCourse;

GolfCourse.default = GolfCourse;
